import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetInventoryQuery } from '../../../api/queries/getInventory';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import { InventoryProvider } from './InventoryContext';
import InventoryDetailsInnerPage from './InventoryDetailsInnerPage';

const InventoryDetailsPage = () => {
    const { inventoryId } = useParams<{ inventoryId: string }>();

    const { data, loading } = useGetInventoryQuery({
        fetchPolicy: 'cache-and-network',
        variables: { id: inventoryId },
    });

    const { permissions: accountPermissions } = useAccount();

    const inventory = data?.inventory;

    if (!inventory && loading) {
        return <LoadingElement />;
    }

    if (!inventory || !hasPermissions(accountPermissions, [permissionKind.viewInventories])) {
        return <NotFoundResult />;
    }

    return (
        <InventoryProvider inventory={inventory}>
            <InventoryDetailsInnerPage inventory={inventory} />
        </InventoryProvider>
    );
};

export default InventoryDetailsPage;
